'use client';

import { memo } from 'react';
import { Alert, Box, CircularProgress } from '@mui/material';
import { MESSAGES } from '../../constants/messages';

const ApiStatusMessage = memo(({ loading, error, success, successMsg, loadingMsg, errorMsg }) => {
  if (loading) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, my: 2 }}>
        <CircularProgress size={20} />
        <Box sx={{ color: 'text.secondary' }}>{loadingMsg || MESSAGES.LOADING.DEFAULT}</Box>
      </Box>
    );
  }

  if (error) {
    return (
      <Alert severity="error" sx={{ my: 2 }}>
        {errorMsg || error || MESSAGES.ERROR.DEFAULT}
      </Alert>
    );
  }

  if (success) {
    return (
      <Alert severity="success" sx={{ my: 2 }}>
        {successMsg || MESSAGES.SUCCESS.DEFAULT}
      </Alert>
    );
  }

  return null;
});

ApiStatusMessage.displayName = 'ApiStatusMessage';

export default ApiStatusMessage;
